import { render, staticRenderFns } from "./UserSelect.vue?vue&type=template&id=1a023f84&scoped=true"
import script from "./UserSelect.vue?vue&type=script&lang=js"
export * from "./UserSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a023f84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a023f84')) {
      api.createRecord('1a023f84', component.options)
    } else {
      api.reload('1a023f84', component.options)
    }
    module.hot.accept("./UserSelect.vue?vue&type=template&id=1a023f84&scoped=true", function () {
      api.rerender('1a023f84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/users/UserSelect.vue"
export default component.exports